import { render, staticRenderFns } from "./feature-section.vue?vue&type=template&id=4aebde07&scoped=true&"
import script from "./feature-section.vue?vue&type=script&lang=js&"
export * from "./feature-section.vue?vue&type=script&lang=js&"
import style0 from "./feature-section.vue?vue&type=style&index=0&id=4aebde07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebde07",
  null
  
)

export default component.exports